import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  listTemplates,
  getTemplate,
  createTemplate,
  updateTemplate,
  type ListTemplatesFilters,
  type TemplateCreateRequest,
  type TemplateUpdateRequest,
} from '../lib/api'
import { toast } from 'sonner'
import { ApiError } from '../lib/api'

const TEMPLATES_QUERY_KEY = 'visual_templates'

export function useVisualTemplates(filters?: ListTemplatesFilters) {
  return useQuery({
    queryKey: [TEMPLATES_QUERY_KEY, filters ?? {}],
    queryFn: () => listTemplates(filters ?? { solo_activos: true }),
  })
}

export function useVisualTemplate(templateId: string | null) {
  return useQuery({
    queryKey: [TEMPLATES_QUERY_KEY, templateId],
    queryFn: () => (templateId ? getTemplate(templateId) : null),
    enabled: !!templateId,
  })
}

export function useCreateTemplate() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: TemplateCreateRequest) => createTemplate(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TEMPLATES_QUERY_KEY] })
      toast.success('Plantilla creada correctamente')
    },
    onError: (error) => {
      if (error instanceof ApiError) {
        toast.error('Error al crear plantilla', { description: error.message })
      } else {
        toast.error('Error inesperado al crear plantilla')
      }
    },
  })
}

export function useUpdateTemplate() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: TemplateUpdateRequest }) =>
      updateTemplate(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TEMPLATES_QUERY_KEY] })
      toast.success('Plantilla actualizada correctamente')
    },
    onError: (error) => {
      if (error instanceof ApiError) {
        toast.error('Error al actualizar plantilla', { description: error.message })
      } else {
        toast.error('Error inesperado al actualizar plantilla')
      }
    },
  })
}
